function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import HubspotContactForm from "segments/desktop/core-components/hubspot-contact-form/hubspot-contact-form";
import HubspotContactFormProps from "segments/desktop/core-components/hubspot-contact-form/default-props";
import ParagraphAndLogos from "segments/desktop/core-components/paragraph-and-logos/paragraph-and-logos";
import { StyledHubspotAndLogosFormComponent } from "./hubspot-and-logos-form-component.scss";
const NINE_LOGOS_MAX_WIDTH = "590px";
const HubspotAndLogosFormComponent = (props)=>{
    const { formId, source, overrideCampaignId, paragraphAndLogos, lastNameFirst, bookAMeetingFlowUrl, bamTimeout, enableLoader } = props, restProps = _object_without_properties(props, [
        "formId",
        "source",
        "overrideCampaignId",
        "paragraphAndLogos",
        "lastNameFirst",
        "bookAMeetingFlowUrl",
        "bamTimeout",
        "enableLoader"
    ]);
    const replaceTextComponentProps = {
        formId,
        bookAMeetingFlowUrl,
        bamTimeout,
        enableLoader,
        source,
        overrideCampaignId,
        lastNameFirst
    };
    const replaceAssetComponentProps = useMemo(()=>{
        var _paragraphAndLogos_logos;
        if ((paragraphAndLogos === null || paragraphAndLogos === void 0 ? void 0 : (_paragraphAndLogos_logos = paragraphAndLogos.logos) === null || _paragraphAndLogos_logos === void 0 ? void 0 : _paragraphAndLogos_logos.numberOfCompanies) === "9") {
            paragraphAndLogos.logosMaxWidth = NINE_LOGOS_MAX_WIDTH;
        }
        return _object_spread({}, paragraphAndLogos);
    }, [
        paragraphAndLogos
    ]);
    return /*#__PURE__*/ _jsx(StyledHubspotAndLogosFormComponent, {
        className: "hubspot-and-logos-form-component",
        children: /*#__PURE__*/ _jsx(SideBySideTextAndAsset, _object_spread_props(_object_spread({
            replaceTextComponent: HubspotContactForm
        }, restProps), {
            replaceTextComponentProps: replaceTextComponentProps,
            replaceAssetComponent: ParagraphAndLogos,
            replaceAssetComponentProps: replaceAssetComponentProps
        }))
    });
};
export default HubspotAndLogosFormComponent;
HubspotAndLogosFormComponent.defaultProps = _object_spread_props(_object_spread({
    width: "100%"
}, HubspotContactFormProps), {
    paragraphAndLogos: ParagraphAndLogos.defaultProps
});
